var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.$style['header-wrapper']},[_c('div',{class:_vm.$style.title},[_vm._t("title",function(){return [_vm._v("Title")]})],2),_c('div',{class:_vm.$style.content,style:(_vm.style)},[_vm._t("content")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }